import { FileText } from 'lucide-react'

export default function Invoices() {
  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Invoices</h1>
      <div className="card p-12 text-center">
        <FileText className="h-12 w-12 text-gray-300 mx-auto mb-4" />
        <h2 className="text-lg font-semibold text-gray-500 mb-2">Work in Progress</h2>
        <p className="text-sm text-gray-400">Invoice management is coming soon.</p>
      </div>
    </div>
  )
}
